import React, { Component } from "react";
import Dashboard from "../../layouts/DashboardLayOut";
import Privilege from "../../components/PrivilegeManagement/Privilege";

export class index extends Component {
  render() {
    return (
      <Dashboard>
        <Privilege />
      </Dashboard>
    );
  }
}

export default index;
